require.register("modules/m06/a01/page-2/page-2", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page2 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page2;

  
});

